import { Location } from "history";

export const setUnsavedChanges = (location: Location, hasChanges: boolean) => {
  try {
    localStorage.setItem(
      `certain.unsavedChanges.${location.pathname.replaceAll("/", ".")}`,
      hasChanges.toString(),
    );
  } catch {
    /* Editing must work when storage is unavailable. */
  }
};

export const hasUnsavedChanges = (location: Location) => {
  try {
    const lsKey = localStorage.getItem(
      `certain.unsavedChanges.${location.pathname.replaceAll("/", ".")}`,
    );

    //   default to true to indicate that there might be unsaved changes
    if (!lsKey) {
      return true;
    }

    return JSON.parse(lsKey);
  } catch (error) {
    return true;
  }
};

export const setReferral = (referral: string) => {
  localStorage.setItem("certain.referral", referral);
};

export const getReferral = (): string | null => {
  return localStorage.getItem("certain.referral");
};

export const clearReferral = () => {
  localStorage.removeItem("certain.referral");
};
